(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-notice"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'hlam_cookie_notice_dismissed_v2';
    var notice = document.getElementById('cookie-notice');
    if (!notice) return;

    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') return;
    } catch (e) { /* localStorage blocked: fall through and still show */ }

    notice.removeAttribute('hidden');

    notice.querySelector('[data-cookie-dismiss]').addEventListener('click', function () {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      notice.setAttribute('hidden', '');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.founder__gallery').forEach((g) => {
      if (g.closest('.founder--gallery-marquee')) {
        initMarquee(g);
      } else {
        initGallery(g);
      }
    });

    function initMarquee(gallery) {
      const track = gallery.querySelector('.founder__gallery-track');
      if (!track) return;
      const speed = 40; // px/sec
      const dir = gallery.dataset.marqueeReverse === 'true' ? -1 : 1;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let pos = 0;
      let auto = !reduceMotion;
      let lastTime = 0;
      let isDown = false;
      let startX = 0;
      let startPos = 0;
      let dragged = false;
      let resumeTimer = 0;

      const halfWidth = () => track.scrollWidth / 2;

      const wrap = () => {
        const half = halfWidth();
        if (half <= 0) return;
        if (pos >= half) pos -= half;
        else if (pos < 0) pos += half;
      };

      const apply = () => {
        track.style.transform = `translate3d(${-pos}px, 0, 0)`;
      };

      const tick = (now) => {
        if (lastTime && auto && !isDown) {
          const dt = (now - lastTime) / 1000;
          pos += dir * speed * dt;
          wrap();
          apply();
        }
        lastTime = now;
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);

      const pauseAuto = () => {
        auto = false;
        clearTimeout(resumeTimer);
      };
      const queueResume = (delayMs) => {
        clearTimeout(resumeTimer);
        if (reduceMotion) return;
        resumeTimer = setTimeout(() => { auto = true; }, delayMs);
      };

      gallery.addEventListener('mouseenter', pauseAuto);
      gallery.addEventListener('mouseleave', () => queueResume(150));
      gallery.addEventListener('focusin', pauseAuto);
      gallery.addEventListener('focusout', () => queueResume(150));

      // Mouse drag
      gallery.addEventListener('mousedown', (e) => {
        isDown = true;
        dragged = false;
        gallery.classList.add('is-dragging');
        startX = e.pageX;
        startPos = pos;
        pauseAuto();
        e.preventDefault();
      });
      gallery.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const dx = e.pageX - startX;
        if (Math.abs(dx) > 4) dragged = true;
        pos = startPos - dx;
        wrap();
        apply();
      });
      const stopDrag = () => {
        if (!isDown) return;
        isDown = false;
        gallery.classList.remove('is-dragging');
        queueResume(800);
      };
      gallery.addEventListener('mouseup', stopDrag);
      gallery.addEventListener('mouseleave', stopDrag);
      gallery.addEventListener('click', (e) => {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        }
      }, true);

      // Touch swipe
      let touchStartX = 0;
      let touchStartPos = 0;
      let touchActive = false;
      gallery.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        touchActive = true;
        touchStartX = e.touches[0].clientX;
        touchStartPos = pos;
        pauseAuto();
      }, { passive: true });
      gallery.addEventListener('touchmove', (e) => {
        if (!touchActive || e.touches.length !== 1) return;
        const dx = e.touches[0].clientX - touchStartX;
        pos = touchStartPos - dx;
        wrap();
        apply();
      }, { passive: true });
      const endTouch = () => {
        if (!touchActive) return;
        touchActive = false;
        queueResume(1200);
      };
      gallery.addEventListener('touchend', endTouch, { passive: true });
      gallery.addEventListener('touchcancel', endTouch, { passive: true });
    }

    function initGallery(gallery) {
      const updateScrollable = () => {
        if (gallery.scrollWidth - gallery.clientWidth > 1) {
          gallery.classList.add('founder__gallery--scrollable');
        } else {
          gallery.classList.remove('founder__gallery--scrollable');
        }
      };
      updateScrollable();
      window.addEventListener('resize', updateScrollable);

      let isDown = false;
      let startX = 0;
      let scrollStart = 0;
      let dragged = false;

      gallery.addEventListener('mousedown', (e) => {
        if (!gallery.classList.contains('founder__gallery--scrollable')) return;
        isDown = true;
        dragged = false;
        gallery.classList.add('is-dragging');
        startX = e.pageX - gallery.offsetLeft;
        scrollStart = gallery.scrollLeft;
        e.preventDefault();
      });

      const stop = () => {
        if (!isDown) return;
        isDown = false;
        gallery.classList.remove('is-dragging');
      };
      gallery.addEventListener('mouseleave', stop);
      gallery.addEventListener('mouseup', stop);

      gallery.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - gallery.offsetLeft;
        const walk = (x - startX) * 1.2;
        if (Math.abs(walk) > 4) dragged = true;
        gallery.scrollLeft = scrollStart - walk;
      });

      gallery.addEventListener('click', (e) => {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        }
      }, true);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
